import { Fragment } from "react";
import { Badge } from "reactstrap";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { ChatsTypes, MessageTypes } from "../../../../../Types/MessengerType";
import { dynamicImage, Image } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon";
import ChatLoader from "./ChatLoader";
import DocumentChat from "./DocumentChat";
import PhotosChat from "./PhotosChat";
import UserGroup from "./UserGroup";

const Chat = () => {
  const { allMembers, chats, selectedUser, currentUser } = useAppSelector((state) => state.chat);
  const { subChatActiveTab } = useAppSelector((state) => state.messenger);
  const selectedChat = allMembers && chats && selectedUser ? chats.find((x: ChatsTypes) => x.users.includes(currentUser?.id as number) && x.users.includes(selectedUser.id)) : null;

  return (
    <div className="contact-chat">
      <ul className="chatappend">
        {subChatActiveTab === "group" && <UserGroup />}
        {selectedChat && selectedChat.messages.length > 0 ? (
          selectedChat.messages.map((item: MessageTypes, index: number) => {
            return (
              <li className={item.class} key={index}>
                <div className="d-flex align-items-end">
                  {item.sender !== currentUser?.id && (
                    <Fragment>
                      {selectedUser?.thumb ? (
                        <div className="profile">
                          <Image src={dynamicImage(`${selectedUser?.thumb}`)} className="bg-img img-fluid" alt="user" />
                        </div>
                      ) : (
                        <div className={`profile ${selectedUser?.onlineStatus}`}>
                          <span>{selectedUser?.name.split(" ").map((name) => name[0])}</span>
                        </div>
                      )}
                    </Fragment>
                  )}
                  <div className="flex-grow-1">
                    <div className="contact-name">
                      <ul className="msg-box">
                        <li className={item.photos ? "gallery-img" : "msg-setting-main"}>
                          {item.text && <h5>{item.text}</h5>}
                          {item.liked && (<Badge color="white" className="badge-img sm">❤️</Badge>)}
                          {item.document && <DocumentChat />}
                          {item.photos && <PhotosChat />}
                          {item.stickers ? <Image src={item.stickers} alt="" /> : ""}
                        </li>
                      </ul>
                      <h6 className={item.font_class}>
                        {item.font_class && <SvgIcon className="fill-primary" iconId="danger" />}
                        {item.seen && <SvgIcon className="fill-primary" iconId="right-2" />}
                        {item.time}
                      </h6>
                    </div>
                  </div>
                </div>
              </li>
            );
          })
        ) : (
          <div className="call-list-center">
            <Image src={dynamicImage("chat.gif")} alt="#" />
            <h2>You’ve not chat yet !!</h2>
            <p>There is no chat done yet. Click on Below Button to start chat</p>
          </div>
        )}
        <ChatLoader />
      </ul>
    </div>
  );
};

export default Chat;
